<script setup lang="ts">import { ref as _ref } from 'vue';

import type { Component } from 'vue'
import { usePage } from '@inertiajs/vue3'

// Imports the reveal (and reCAPTCHA with it) only once a page offers a challenge,
// then keeps it mounted so client-side navigations are covered too.
const page = usePage()
let reveal = _ref<Component>()

watchEffect(() => {
  if (reveal.value || !page.props?.canRevealContent) return

  import('@shared/components/SensitiveContentReveal.vue').then((module) => {
    reveal.value = module.default
  })
})
</script>

<template>
  <component :is="reveal" v-if="reveal"/>
</template>
